import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CInput from "../../../components/elements/customInput";
import CCheckbox from "../../../components/elements/customCheckbox";
import CRadio from "../../../components/elements/customRadioBtn";
import FilePicker from "../../../components/elements/filepicker";
import DatePicker from "../../../components/elements/datepicker";
import CTextarea from "../../../components/elements/customTextarea";
import SearchInput from "../../../components/elements/searchInput";

import { scrollToElement } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";
import { ClaimStatementStepTwoRadioButtons, StatementComponentNames } from "../../../helpers/data";

import ClaimStatementStepOne from "./step-1";
import ClaimStatementStepThree from "./step-3";

const ClaimStatementStepTwo = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="2"
      step-amount="3"
    />

    <div class="statement-middle">

    <div class="statement__step statement__step-2">
        <div class="area">
          <div class="area-form">
            <p class="h5">Параметры совершенного перевода</p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <DatePicker 
                :ref="ref_names.transaction_date"
                :name="transaction_date.name"
                :title="transaction_date.title"
                :type="transaction_date.type"
                :required="transaction_date.required"
                v-model="data.transaction_date"
                :validation="transaction_date.validation"
                :mask="transaction_date.mask"
              />
              <div class="area-form__fields-item">
                <SearchInput
                  :ref="ref_names.transaction_provider"
                  :name="transaction_provider.name"
                  :placeholder="transaction_provider.placeholder"
                  :type="transaction_provider.type"
                  :options-list="transaction_provider_options"
                  :initial-value="{
                    text: data.transaction_provider_option.text,
                    id: data.transaction_provider_option.id,
                    icon: data.transaction_provider_option.icon,
                    selected: data.transaction_provider_option.selected,
                  }"
                  @selected_option="selectTransactionProvider"
                  @clear_option="clearTransactionProvider"
                  search-input-id="transaction_provider"
                  :required="transaction_provider.required"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_id"
                  :name="transaction_id.name"
                  :title="transaction_id.title"
                  :type="transaction_id.type"
                  :required="transaction_id.required"
                  :validation="transaction_id.validation"
                  v-model="data.transaction_id"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_summ"
                  :name="transaction_summ.name"
                  :title="transaction_summ.title"
                  :type="transaction_summ.type"
                  :required="transaction_summ.required"
                  :validation="transaction_summ.validation"
                  v-model="data.transaction_summ"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Платеж<span>*</span></p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.payment_not_recieved"
                  :name="payment_not_recieved.name"
                  :title="payment_not_recieved.title"
                  :value="payment_not_recieved.value"
                  :radio-id="payment_not_recieved.id"
                  :checked="payment_not_recieved.checked"
                  v-model="data.payment_claim"
                />
              </div>
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.payment_delayed"
                  :name="payment_delayed.name"
                  :title="payment_delayed.title"
                  :value="payment_delayed.value"
                  :radio-id="payment_delayed.id"
                  :checked="payment_delayed.checked"
                  v-model="data.payment_claim"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">В связи с чем <span>*</span></p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.credit_payment_delayed"
                  :name="credit_payment_delayed.name"
                  :title="credit_payment_delayed.title"
                  :value="credit_payment_delayed.value"
                  :radio-id="credit_payment_delayed.id"
                  :checked="credit_payment_delayed.checked"
                  v-model="data.payment_reason"
                />
              </div>
              <div class="area-form__fields grid col-xxl-2 col-md-1" v-if="data.payment_reason === credit_payment_delayed.value">
                <div class="area-form__fields-item">
                  <DatePicker 
                    :ref="ref_names.credit_payment_delayed_date"
                    :name="credit_payment_delayed_date.name"
                    :title="credit_payment_delayed_date.title"
                    :type="credit_payment_delayed_date.type"
                    :required="credit_payment_delayed_date.required"
                    v-model="data.credit_payment_delayed_date"
                    :validation="credit_payment_delayed_date.validation"
                    :mask="credit_payment_delayed_date.mask"
                  />
                </div>
                <div class="area-form__fields-item">
                  <CInput
                    :ref="ref_names.credit_payment_delayed_transaction_summ"
                    :name="credit_payment_delayed_transaction_summ.name"
                    :title="credit_payment_delayed_transaction_summ.title"
                    :type="credit_payment_delayed_transaction_summ.type"
                    :required="credit_payment_delayed_transaction_summ.required"
                    :validation="credit_payment_delayed_transaction_summ.validation"
                    v-model="data.credit_payment_delayed_transaction_summ"
                  />
                </div>
              </div>
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.credit_debt_payment_delayed"
                  :name="credit_debt_payment_delayed.name"
                  :title="credit_debt_payment_delayed.title"
                  :value="credit_debt_payment_delayed.value"
                  :radio-id="credit_debt_payment_delayed.id"
                  :checked="credit_debt_payment_delayed.checked"
                  v-model="data.payment_reason"
                />
              </div>
              <div class="area-form__fields grid col-xxl-2 col-md-1" v-if="data.payment_reason === credit_debt_payment_delayed.value">
                <div class="area-form__fields-item">
                  <DatePicker 
                    :ref="ref_names.credit_debt_payment_delayed_date"
                    :name="credit_debt_payment_delayed_date.name"
                    :title="credit_debt_payment_delayed_date.title"
                    :type="credit_debt_payment_delayed_date.type"
                    :required="credit_debt_payment_delayed_date.required"
                    v-model="data.credit_debt_payment_delayed_date"
                    :validation="credit_debt_payment_delayed_date.validation"
                    :mask="credit_debt_payment_delayed_date.mask"
                  />
                </div>
                <div class="area-form__fields-item">
                  <CInput
                    :ref="ref_names.credit_debt_payment_delayed_transaction_summ"
                    :name="credit_debt_payment_delayed_transaction_summ.name"
                    :title="credit_debt_payment_delayed_transaction_summ.title"
                    :type="credit_debt_payment_delayed_transaction_summ.type"
                    :required="credit_debt_payment_delayed_transaction_summ.required"
                    :validation="credit_debt_payment_delayed_transaction_summ.validation"
                    v-model="data.credit_debt_payment_delayed_transaction_summ"
                  />
                </div>
              </div>
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.payment_reason_other"
                  :name="payment_reason_other.name"
                  :title="payment_reason_other.title"
                  :value="payment_reason_other.value"
                  :radio-id="payment_reason_other.id"
                  :checked="payment_reason_other.checked"
                  v-model="data.payment_reason"
                />
              </div>
              <div class="area-form__fields grid col-xxl-2 col-md-1" v-if="data.payment_reason === payment_reason_other.value">
                <div class="area-form__fields-item">
                  <CTextarea
                    :ref="ref_names.payment_reason_other_text"
                    :name="payment_reason_other_text.name"
                    :title="payment_reason_other_text.title"
                    :required="payment_reason_other_text.required"
                    :validation="payment_reason_other_text.validation"
                    v-model="data.payment_reason_other_text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Штрафные санкции в связи с несвоевременным погашением кредитной задолженности Банком/Компанией <span>*</span></p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <CRadio
                  :ref="ref_names.debt_fine_not_applied"
                  :name="debt_fine_not_applied.name"
                  :title="debt_fine_not_applied.title"
                  :value="debt_fine_not_applied.value"
                  :radio-id="debt_fine_not_applied.id"
                  :checked="debt_fine_not_applied.checked"
                  v-model="data.debt_fine"
                />
              </div>
              <div class="area-form__fields grid col-xxl-1">
                <div class="area-form__fields-item">
                  <CRadio
                    :ref="ref_names.debt_fine_applied"
                    :name="debt_fine_applied.name"
                    :title="debt_fine_applied.title"
                    :value="debt_fine_applied.value"
                    :radio-id="debt_fine_applied.id"
                    :checked="debt_fine_applied.checked"
                    v-model="data.debt_fine"
                  />
                </div>
                <div class="area-form__fields grid col-xxl-2 col-md-1" v-if="data.debt_fine === debt_fine_applied.value">
                  <div class="area-form__fields-item">
                    <CInput
                      :ref="ref_names.debt_fine_text"
                      :name="debt_fine_text.name"
                      :title="debt_fine_text.title"
                      :type="debt_fine_text.type"
                      :required="debt_fine_text.required"
                      :validation="debt_fine_text.validation"
                      v-model="data.debt_fine_text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Дополнительная информация <span></span></p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.additional_info"
                  :name="additional_info.name"
                  :title="additional_info.title"
                  :required="additional_info.required"
                  :validation="additional_info.validation"
                  v-model="data.additional_info"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <div class="area-form__fields grid col-xxl-2 col-lg-1">
              <div class="area-form__fields-item">
                <p class="h5">Извещение об оплате или другой документ подтверждающий оплату <span>*</span></p>
              </div>
              <div class="area-form__fields-item check-copy">
                <CCheckbox
                  :title="transaction_document_copy.title"
                  :checkbox-id="transaction_document_copy.id"
                  :check-var="data.transaction_document_copy_attached"
                  @on_change="onTransactionDocumentCopyAttached"
                />
              </div>
              <div class="area-form__fields-item" v-if="data.transaction_document_copy_attached">
                <FilePicker 
                  :ref="ref_names.transaction_document_file"
                  :show-notification="transaction_document_file.show_notification"
                  :notification="transaction_document_file.notification"
                  :initial-value="[...data.transaction_document_files]"
                  :required="transaction_document_file.required"
                  :multiple="transaction_document_file.multiple"
                  @files_picked="onTransactionDocumentFilesPicked"
                  @clear_files="onTransactionDocumentFilesCleared"
                />
              </div>
              <div class="area-form__fields-item" v-else>
                <CTextarea
                    :ref="ref_names.no_transaction_document_reason"
                    :name="no_transaction_document_reason.name"
                    :title="no_transaction_document_reason.title"
                    :required="no_transaction_document_reason.required"
                    :validation="no_transaction_document_reason.validation"
                    v-model="data.no_transaction_document_reason"
                  />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <div class="area-form__fields grid col-xxl-2 col-lg-1">
              <div class="area-form__fields-item">
                <p class="h5">Документы, подтверждающие начисление штрафных санкций и/или иных расходов
                <span>*</span></p>
              </div>
              <div class="area-form__fields-item check-copy">
                <CCheckbox
                  :title="debt_fine_document_copy.title"
                  :checkbox-id="debt_fine_document_copy.id"
                  :check-var="data.debt_fine_document_copy_attached"
                  @on_change="onDebtFineDocumentCopyAttached"
                />
              </div>
              <div class="area-form__fields-item" v-if="data.debt_fine_document_copy_attached">
                <FilePicker 
                  :ref="ref_names.debt_fine_document_file"
                  :show-notification="debt_fine_document_file.show_notification"
                  :notification="debt_fine_document_file.notification"
                  :initial-value="[...data.debt_fine_document_files]"
                  :required="debt_fine_document_file.required"
                  :multiple="debt_fine_document_file.multiple"
                  @files_picked="onDebtFineDocumentFilesPicked"
                  @clear_files="onDebtFineDocumentFilesCleared"
                />
              </div>
              <div class="area-form__fields-item" v-else>
                <CTextarea
                    :ref="ref_names.no_debt_fine_document_reason"
                    :name="no_debt_fine_document_reason.name"
                    :title="no_debt_fine_document_reason.title"
                    :required="no_debt_fine_document_reason.required"
                    :validation="no_debt_fine_document_reason.validation"
                    v-model="data.no_debt_fine_document_reason"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    name: StatementComponentNames.claim.claim_two,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
          type: Function
        }
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.claim.data,
        }),
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Продолжить",
                class: "",
            },

            back_btn: {
                show: true,
                text: "Назад",
                class: "",
            },

            transaction_date: {
                name: "transaction_date",
                title: "Дата",
                required: true,
                type: "text",
                validation: [["required"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                },
            },

            transaction_provider: {
                name: "transaction_provider",
                placeholder: "Поиск по Услугам/Операторам",
                type: "text",
                required: true,
            },

            transaction_provider_options: [],

            transaction_id: {
                name: "transaction_id",
                title: "Идентификатор (счет, договор и т.д.)",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\d\s\W]+$/i], ["max", 300]],
                mask: {
                    mask: "999999999999999",
                    showMaskOnHover: !1,
                },
            },

            transaction_summ: {
                name: "transaction_summ",
                title: "Сумма, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            payment_not_recieved: {
                name: "payment_claim",
                title: ClaimStatementStepTwoRadioButtons.payment_not_recieved.text,
                id: "payment_not_recieved",
                value: ClaimStatementStepTwoRadioButtons.payment_not_recieved.value,
                checked: false,
            },

            payment_delayed: {
                name: "payment_claim",
                title: ClaimStatementStepTwoRadioButtons.payment_delayed.text,
                id: "payment_delayed",
                value: ClaimStatementStepTwoRadioButtons.payment_delayed.value,
                checked: false,
            },

            credit_payment_delayed: {
                name: "payment_reason",
                title: ClaimStatementStepTwoRadioButtons.credit_payment_delayed.text,
                id: "credit_payment_delayed",
                value: ClaimStatementStepTwoRadioButtons.credit_payment_delayed.value,
                checked: false,
            },

            credit_payment_delayed_date: {
                name: "credit_payment_delayed_date",
                title: "Дата",
                required: true,
                type: "text",
                validation: [["required"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                },
            },

            credit_payment_delayed_transaction_summ: {
                name: "credit_payment_delayed_transaction_summ",
                title: "Сумма ежемесячного платежа по договору, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            credit_debt_payment_delayed: {
                name: "payment_reason",
                title: "задолженность по кредитному и иному договору не была погашена вовремя",
                id: ClaimStatementStepTwoRadioButtons.credit_debt_payment_delayed.text,
                value: ClaimStatementStepTwoRadioButtons.credit_debt_payment_delayed.value,
                checked: false,
            },

            credit_debt_payment_delayed_date: {
                name: "credit_debt_payment_delayed_date",
                title: "Дата",
                required: true,
                type: "text",
                validation: [["required"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                },
            },

            credit_debt_payment_delayed_transaction_summ: {
                name: "credit_debt_payment_delayed_transaction_summ",
                title: "Сумма, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            payment_reason_other: {
                name: "payment_reason",
                title: ClaimStatementStepTwoRadioButtons.payment_reason_other.text,
                id: "payment_reason_other",
                value: ClaimStatementStepTwoRadioButtons.payment_reason_other.value,
                checked: false,
            },

            payment_reason_other_text: {
                name: "payment_reason_other_text",
                title: "Сообщение",
                required: true,
                validation: [["required"], ["max", 300]],
            },

            debt_fine_not_applied: {
                name: "debt_fine",
                title: ClaimStatementStepTwoRadioButtons.debt_fine_not_applied.text,
                id: "debt_fine_not_applied",
                value: ClaimStatementStepTwoRadioButtons.debt_fine_not_applied.value,
                checked: false,
            },

            debt_fine_applied: {
                name: "debt_fine",
                title: ClaimStatementStepTwoRadioButtons.debt_fine_applied.text,
                id: "debt_fine_applied",
                value: ClaimStatementStepTwoRadioButtons.debt_fine_applied.value,
                checked: false,
            },

            debt_fine_text: {
                name: "debt_fine",
                title: "Сумма санкций в размере, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            additional_info: {
                name: "additional_info",
                title: "Информация, которую Вы считаете нужным указать",
                required: false,
                validation: [["optional"], ["max", 300]],
            },

            transaction_document_copy: {
                name: "transaction_document_copy",
                title: "К заявлению прилагаю копию Извещения об оплате или другой документ подтверждающий оплату",
                id: "transaction_document_copy",
            },

            transaction_document_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: true,
                multiple: true,
            },

            no_transaction_document_reason: {
                name: "no_transaction_document_reason",
                title: "Причина отсутствия копии Извещения об оплате или другого документа, подтверждающего оплату",
                required: true,
                validation: [["required"], ["max", 300]],
            },

            debt_fine_document_copy: {
                name: "debt_fine_document_copy",
                title: "К заявлению прилагаю копию документов, подтверждающих начисление штрафных санкций и/или иных расходов",
                id: "debt_fine_document_copy",
            },

            debt_fine_document_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: true,
                multiple: true,
            },

            no_debt_fine_document_reason: {
                name: "no_debt_fine_document_reason",
                title: "Причина отсутствия документов, подтверждающих начисление штрафных санкций и/или иных расходов",
                required: true,
                validation: [["required"], ["max", 300]],
            },

            data: {
                transaction_date: "",

                transaction_provider_option: {
                    text: null,
                    id: null,
                    icon: null,
                    selected: false,
                },

                transaction_id: "",
                transaction_summ: "",
                payment_claim: "",
                payment_reason: "",
                credit_payment_delayed_date: "",
                credit_payment_delayed_transaction_summ: "",
                credit_debt_payment_delayed_date: "",
                credit_debt_payment_delayed_transaction_summ: "",
                payment_reason_other_text: "",
                debt_fine: "",
                debt_fine_text: "",
                additional_info: "",

                transaction_document_copy_attached: true,

                transaction_document_files: [],

                no_transaction_document_reason: "",

                debt_fine_document_copy_attached: true,

                debt_fine_document_files: [],

                no_debt_fine_document_reason: "",
            },

            ref_names: {
                transaction_date: "transaction_date",
                transaction_provider: "transaction_provider",
                transaction_id: "transaction_id",
                transaction_summ: "transaction_summ",
                payment_not_recieved: "payment_not_recieved",
                payment_delayed: "payment_delayed",

                credit_payment_delayed: "credit_payment_delayed",
                credit_payment_delayed_date: "credit_payment_delayed_date",
                credit_payment_delayed_transaction_summ: "credit_payment_delayed_transaction_summ",
                credit_debt_payment_delayed: "credit_debt_payment_delayed",
                credit_debt_payment_delayed_date: "credit_debt_payment_delayed_date",
                credit_debt_payment_delayed_transaction_summ: "credit_debt_payment_delayed_transaction_summ",
                payment_reason_other: "payment_reason_other",
                payment_reason_other_text: "payment_reason_other_text",

                debt_fine_not_applied: "debt_fine_not_applied",
                debt_fine_applied: "debt_fine_applied",
                debt_fine_text: "debt_fine_text",

                additional_info: "additional_info",

                transaction_document_file: "transaction_document_file",
                no_transaction_document_reason: "no_transaction_document_reason",

                debt_fine_document_file: "debt_fine_document_file",
                no_debt_fine_document_reason: "no_debt_fine_document_reason",
            },

            ref_order: [],

            refs_with_errors: [],

            form_has_errors: false,
        };
    },

    watch: {
        "data.payment_claim": function () {
            this.fillRefOrder();
        },

        "data.payment_reason": function () {
            this.fillRefOrder();
        },

        "data.debt_fine": function () {
            this.fillRefOrder();
        },
    },

    created() {
        this.transaction_provider_options = this.$bitrix.Application.instance.php_vars.provider_options;
        this.getStoreData();

        this.setDefalutValues();

        this.fillRefOrder();
        this.onTransactionDocumentCopyAttached(this.data.transaction_document_copy_attached);
        this.onDebtFineDocumentCopyAttached(this.data.debt_fine_document_copy_attached);
    },

    methods: {
        onBackClicked() {
            this.setStatementData();
            this.scrollToTop();
            this.goToComponent({ component: ClaimStatementStepOne })
        },

        async onNextClicked() {
            this.setStatementData();

            await this.submitForm();

            if (!this.form_has_errors) {
                this.scrollToTop();
                this.goToComponent({ component: ClaimStatementStepThree })
            }
        },

        clearTransactionProviderOptions() {
            this.transaction_provider_options.forEach((option) => {
                if (option.selected) {
                    option.selected = false;
                }
            });
        },

        selectTransactionProvider(option) {
            this.clearTransactionProviderOptions();

            this.data.transaction_provider_option.text = option.text;
            this.data.transaction_provider_option.id = option.id;
            this.data.transaction_provider_option.selected = option.selected;
            this.data.transaction_provider_option.icon = option.icon;

            this.transaction_provider_options.forEach((item) => {
                if (option.id === item.id) {
                    item.selected = true;
                }
            });
        },

        clearTransactionProvider() {
            this.data.transaction_provider_option.icon = null;
            this.data.transaction_provider_option.id = null;
            this.data.transaction_provider_option.selected = false;

            this.clearTransactionProviderOptions();
        },

        setDefalutValues() {
            if (!this.data.payment_claim) {
                this.data.payment_claim = this.payment_delayed.value;
            }

            if (!this.data.payment_reason) {
                this.data.payment_reason = this.credit_payment_delayed.value;
            }

            if (!this.data.debt_fine) {
                this.data.debt_fine = this.debt_fine_applied.value;
            }

            if (this.data.payment_claim === this.payment_not_recieved.value) {
                this.payment_not_recieved.checked = true;
            }

            if (this.data.payment_claim === this.payment_delayed.value) {
                this.payment_delayed.checked = true;
            }

            if (this.data.payment_reason === this.credit_payment_delayed.value) {
                this.credit_payment_delayed.checked = true;
            }

            if (this.data.payment_reason === this.credit_debt_payment_delayed.value) {
                this.credit_debt_payment_delayed.checked = true;
            }

            if (this.data.payment_reason === this.payment_reason_other.value) {
                this.payment_reason_other.checked = true;
            }

            if (this.data.debt_fine === this.debt_fine_applied.value) {
                this.debt_fine_applied.checked = true;
            }

            if (this.data.debt_fine === this.debt_fine_not_applied.value) {
                this.debt_fine_not_applied.checked = true;
            }

            if (this.data.transaction_provider_option.id) {
                this.selectTransactionProvider(this.data.transaction_provider_option);
            }
        },

        fillRefOrder() {
            this.ref_order = [
                this.ref_names.transaction_date,
                this.ref_names.transaction_provider,
                this.ref_names.transaction_id,
                this.ref_names.transaction_summ,
                this.ref_names.additional_info,
            ];

            if (this.data.payment_reason === this.credit_payment_delayed.value) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_summ);

                this.ref_order.splice(index + 1, 0, this.ref_names.credit_payment_delayed_date);
                this.ref_order.splice(index + 2, 0, this.ref_names.credit_payment_delayed_transaction_summ);
            }

            if (this.data.payment_reason === this.credit_debt_payment_delayed.value) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_summ);

                this.ref_order.splice(index + 1, 0, this.ref_names.credit_debt_payment_delayed_date);
                this.ref_order.splice(index + 2, 0, this.ref_names.credit_debt_payment_delayed_transaction_summ);
            }

            if (this.data.payment_reason === this.payment_reason_other.value) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_summ);

                this.ref_order.splice(index + 1, 0, this.ref_names.payment_reason_other_text);
            }

            if (this.data.debt_fine === this.debt_fine_applied.value) {
                if (this.data.payment_reason === this.credit_payment_delayed.value) {
                    const index = this.ref_order.findIndex(
                        (item) => item === this.ref_names.credit_payment_delayed_transaction_summ
                    );
                    this.ref_order.splice(index + 1, 0, this.ref_names.debt_fine_text);
                }

                if (this.data.payment_reason === this.credit_debt_payment_delayed.value) {
                    const index = this.ref_order.findIndex(
                        (item) => item === this.ref_names.credit_debt_payment_delayed_transaction_summ
                    );
                    this.ref_order.splice(index + 1, 0, this.ref_names.debt_fine_text);
                }

                if (this.data.payment_reason === this.payment_reason_other.value) {
                    const index = this.ref_order.findIndex((item) => item === this.ref_names.payment_reason_other_text);
                    this.ref_order.splice(index + 1, 0, this.ref_names.debt_fine_text);
                }
            }

            if (this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.additional_info);
                this.ref_order.splice(index + 1, 0, this.ref_names.transaction_document_file);
            }

            if (!this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.additional_info);
                this.ref_order.splice(index + 1, 0, this.ref_names.no_transaction_document_reason);
            }

            if (this.data.debt_fine_document_copy_attached) {
                if (this.data.transaction_document_copy_attached) {
                  const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_document_file);
                  this.ref_order.splice(index + 1, 0, this.ref_names.debt_fine_document_file);
                }

                if (!this.data.transaction_document_copy_attached) {
                  const index = this.ref_order.findIndex((item) => item === this.ref_names.no_transaction_document_reason);
                  this.ref_order.splice(index + 1, 0, this.ref_names.debt_fine_document_file);
                }
            }

            if (!this.data.debt_fine_document_copy_attached) {
              if (this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_document_file);
                this.ref_order.splice(index + 1, 0, this.ref_names.no_debt_fine_document_reason);
              }

              if (!this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.no_transaction_document_reason);
                this.ref_order.splice(index + 1, 0, this.ref_names.no_debt_fine_document_reason);
              }
            }
        },

        validateForm() {
            this.refs_with_errors = [];

            this.ref_order.forEach((ref) => {
                const hasError = this.$refs[ref].hasValidationErrors();

                if (hasError) {
                    this.refs_with_errors.push(ref);
                }
            });
        },

        async submitForm() {
            this.form_has_errors = false;
            await this.$nextTick(() => {});

            this.validateForm();

            if (this.refs_with_errors.length) {
                this.form_has_errors = true;
                scrollToElement({ el: this.$refs[this.refs_with_errors[0]].$el, time: 200, animation: "swing", offset: 100 });
            }
        },

        getStoreData() {
            this.data.transaction_date = this.statement_data.transaction_date;
            this.data.transaction_provider_option.text = this.statement_data.transaction_provider_option.text;
            this.data.transaction_provider_option.id = this.statement_data.transaction_provider_option.id;
            this.data.transaction_provider_option.icon = this.statement_data.transaction_provider_option.icon;
            this.data.transaction_provider_option.selected = this.statement_data.transaction_provider_option.selected;

            this.data.transaction_id = this.statement_data.transaction_id;
            this.data.transaction_summ = this.statement_data.transaction_summ;

            this.data.payment_claim = this.statement_data.payment_claim;
            this.data.payment_reason = this.statement_data.payment_reason;
            this.data.credit_payment_delayed_date = this.statement_data.credit_payment_delayed_date;
            this.data.credit_payment_delayed_transaction_summ =
                this.statement_data.credit_payment_delayed_transaction_summ;
            this.data.credit_debt_payment_delayed_date = this.statement_data.credit_debt_payment_delayed_date;
            this.data.credit_debt_payment_delayed_transaction_summ =
                this.statement_data.credit_debt_payment_delayed_transaction_summ;
            this.data.payment_reason_other_text = this.statement_data.payment_reason_other_text;
            this.data.debt_fine = this.statement_data.debt_fine;
            this.data.debt_fine_text = this.statement_data.debt_fine_text;
            this.data.additional_info = this.statement_data.additional_info;

            this.data.transaction_document_copy_attached = this.statement_data.transaction_document_copy_attached;
            this.data.no_transaction_document_reason = this.statement_data.no_transaction_document_reason;

            this.data.transaction_document_files = this.statement_data.transaction_document_files;

            this.data.debt_fine_document_copy_attached = this.statement_data.debt_fine_document_copy_attached;
            this.data.no_debt_fine_document_reason = this.statement_data.no_debt_fine_document_reason;

            this.data.debt_fine_document_files = this.statement_data.debt_fine_document_files;
        },

        setStatementData() {
            this.$store.commit("claim/setSecondStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },

        onTransactionDocumentFilesPicked(files) {
            this.data.transaction_document_files = files;
        },

        onTransactionDocumentFilesCleared() {
            this.data.transaction_document_files = [];
        },

        onTransactionDocumentCopyAttached(val, id) {
            this.data.transaction_document_copy_attached = val;

            if (!this.data.transaction_document_copy_attached) {
                this.onTransactionDocumentFilesCleared();
            }

            if (this.data.transaction_document_copy_attached) {
                this.data.no_transaction_document_reason = "";
            }

            this.fillRefOrder();
        },

        onDebtFineDocumentFilesPicked(files) {
            this.data.debt_fine_document_files = files;
        },

        onDebtFineDocumentFilesCleared() {
            this.data.debt_fine_document_files = [];
        },

        onDebtFineDocumentCopyAttached(val, id) {
            this.data.debt_fine_document_copy_attached = val;

            if (!this.data.debt_fine_document_copy_attached) {
                this.onDebtFineDocumentFilesCleared();
            }

            if (this.data.debt_fine_document_copy_attached) {
                this.data.no_debt_fine_document_reason = "";
            }

            this.fillRefOrder();
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CInput,
        CCheckbox,
        FilePicker,
        DatePicker,
        CTextarea,
        CRadio,
        SearchInput,
        ClaimStatementStepOne,
        ClaimStatementStepThree
    },
};

export default ClaimStatementStepTwo;
